import { IServerPagination } from "app/model"
import { getStore } from "app/store/store"
import {
  CAMPAIGN_STATUSES,
  CAMPAIGN_STATUSES_ACTIVE_OR_LIVE,
  CAMPAIGN_STATUSES_RUNNING_OR_RUNNED,
  ICampaign,
  ICampaignFilters
} from "campaign/model"
import { campaignRPO } from "campaign/repository"
import { state } from "campaign/state"
import { campaignActionCreator } from "campaign/store/actions"
import { getDefaultFilters } from "campaign/store/state"

export function setCampaignFilterPanelExpansion(isExpanded: boolean, isForecast: boolean, isDspDeal: boolean): void {
  const list = isForecast
    ? getStore().getState().campaign.forecastList
    : isDspDeal
      ? getStore().getState().campaign.dspDealList
      : getStore().getState().campaign.campaignList
  if (list.isFilterExpanded === isExpanded) {
    return
  }
  getStore().dispatch(campaignActionCreator.setList(isForecast, isDspDeal, { isFilterExpanded: isExpanded }))
}

export function isStatusRunningOrRunned(status: CAMPAIGN_STATUSES): boolean {
  return CAMPAIGN_STATUSES_RUNNING_OR_RUNNED.includes(status)
}

export const isCampaignLaunchable = (status: CAMPAIGN_STATUSES): boolean =>
  !(
    status === CAMPAIGN_STATUSES.ACTIVE ||
    status === CAMPAIGN_STATUSES.CANCELLED ||
    status === CAMPAIGN_STATUSES.EXPIRED ||
    status === CAMPAIGN_STATUSES.REVIEW ||
    status === CAMPAIGN_STATUSES.RESERVATION
  )

export function isCampaignPausable(status: CAMPAIGN_STATUSES, isForecast: boolean, isDspDeal: boolean): boolean {
  return !isDspDeal && !isForecast && CAMPAIGN_STATUSES_ACTIVE_OR_LIVE.includes(status)
}

export function isCampaignStopable(status: CAMPAIGN_STATUSES) {
  return CAMPAIGN_STATUSES_ACTIVE_OR_LIVE.includes(status)
}

export async function hasCampaignChangedOnServer(campaign: ICampaign): Promise<boolean> {
  const campaignOnServer = await campaignRPO.getCampaign(campaign.id)
  return campaign.updated_at !== campaignOnServer.updated_at
}

export const getCampaignsById = (campaignIds: number[]): Promise<ICampaign[]> =>
  campaignRPO.getCampaigns(
    {
      page: 0,
      pageSize: 10000
    },
    {
      ...getDefaultFilters(false),
      ids: campaignIds
    }
  )

export const getCachedCampaignName = async (campaignId: number): Promise<string> => {
  const campaignName = state.campaignNameById[campaignId]
  if (campaignName !== undefined) {
    return campaignName
  }
  try {
    const campaigns = await getCampaignsById([campaignId])
    if (campaigns.length === 0) {
      state.campaignNameById[campaignId] = "-"
    } else {
      state.campaignNameById[campaignId] = campaigns[0].product || "-"
    }
  } catch (error) {
    console.error(error)
    state.campaignNameById[campaignId] = "-"
  }
  return state.campaignNameById[campaignId]
}

export const getCampaignCount = (filters: ICampaignFilters): Promise<number> => campaignRPO.getCampaignsCount(filters)

export const getCampaigns = (pagination: IServerPagination, filters: ICampaignFilters): Promise<ICampaign[]> =>
  campaignRPO.getCampaigns(pagination, filters)
